import { render } from "./WinnerDocView.vue?vue&type=template&id=49d4ec53"
import script from "./WinnerDocView.vue?vue&type=script&lang=js"
export * from "./WinnerDocView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/ambientaly/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__